import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, StatusPill, fmtDate } from "@/components/Peep";

export default function Subscribers() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/creator/subscribers").then((r) => setD(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="creator-subscribers" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Subscribers</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Your direct members plus PEEPING ALL ACCESS members who can see your membership content.</p>
      </div>
      <Panel title={`Members (${d?.subscribers.length ?? 0})`}>
        {!d ? <p className="text-sm text-[#a7a0af]">Loading…</p> : d.subscribers.length === 0 ? (
          <p data-testid="subscribers-empty" className="text-sm text-[#a7a0af]">No members yet.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[480px] text-left text-sm">
              <thead className="text-[0.65rem] uppercase tracking-wider text-[#a7a0af]"><tr><th className="py-2">Member</th><th>Via</th><th>Since</th><th>Status</th></tr></thead>
              <tbody>
                {d.subscribers.map((s, i) => (
                  <tr key={i} data-testid="subscriber-row" className="border-t border-white/10">
                    <td className="py-2">{s.username}</td>
                    <td className="text-xs">{s.via}</td>
                    <td className="text-xs">{fmtDate(s.since)}</td>
                    <td><StatusPill status={s.cancel_at_period_end && s.status === "active" ? "canceling" : s.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
